let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4Qcwv")).then(() => parcelRequire('45H8T'));